import { FC } from 'react';
import { ImageUrl } from '../../constants/image-urls';
import { TestData } from '../../types';
import { formatPriceFromEUR } from "../../helpers/currency";

interface TestItemNoCategoryDesktopProps {
  testIndex: number;
  test: TestData;
}

export const TestItemNoCategoryDesktop: FC<TestItemNoCategoryDesktopProps> = ({ testIndex, test }) => {

  return (
    <div className={'tests-box '}>
      <a href={`/test/${test.slug}`} key={test.id}
         data-w-id="eabe16cf-6688-4182-9962-4a07cd774e31"
         className="test-link desktop w-full">
        <div className={`row-background ${testIndex % 2 === 0 ? '' : 'bg-gray'}`}>
          <div className="w-layout-grid table-row-grid all two-columns">
            <div id="w-node-eabe16cf-6688-4182-9962-4a07cd774e34-634ceff9"
                 className="table-row-content text-left w-full">
              <div className="name text-left">
                {test.name}
              </div>
            </div>

            <div id="w-node-eabe16cf-6688-4182-9962-4a07cd774e3a-634ceff9"
                 className="table-row-content price">
              <div className="price">
                {(() => {
                  const priceData = formatPriceFromEUR(
                    test.priceEur,
                    test.priceRange
                  );
                  if (priceData) {
                    return (
                      <>
                        <span>{priceData.eur}</span>
                        {priceData.eurRange && (
                          <>
                            <span>&nbsp;-&nbsp;</span>
                            <span>{priceData.eurRange}</span>
                          </>
                        )}
                        <span>&nbsp;/&nbsp;</span>
                        <span>{priceData.bgn}</span>
                        {priceData.bgnRange && (
                          <>
                            <span>&nbsp;-&nbsp;</span>
                            <span>{priceData.bgnRange}</span>
                          </>
                        )}
                      </>
                    );
                  }
                  return <span>-</span>;
                })()}
              </div>
            </div>

            <div className="info-icon">
              <img style={{ display: 'block', opacity: 1 }}
                   loading="lazy"
                   src={ImageUrl.INFO_ICON} alt=""
                   className="normal"/><img
              style={{ opacity: 0, display: 'none' }} loading="lazy"
              src={ImageUrl.INFO_ICON_HOVER}
              alt="" className="hover"/></div>
          </div>
        </div>
      </a>
    </div>
  );
};
